import React, {Component} from 'react';
import iconInstallation from "../../img/general/icon-included.png";
import {connect} from "react-redux";
import moment from "moment";
import {withRouter} from "react-router-dom";
import {createOrder, clearDeliveryData, clearCart} from "../../actionCreators";
import AlertThanks from "../Alerts/AlertThanks.js";

class DeliveredData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAgree: true,
      isSubmit: false,
      isShowThanksPopup: false
    }
  }

  renderCartList = () => {
    const {cart} = this.props;
    const cartElements = cart.map(cartItem => (
      <li key={cartItem.randomId} className="shop-chosen__item">
        <div className="shop-chosen__top">
          <div className="shop-chosen__title">{cartItem.name}</div>
        </div>
        <div className="shop-chosen__bottom">
          <div className="shop-chosen__left">
            <div className="shop-chosen__img">
              <img src={cartItem.icon} alt="" />
            </div>
          </div>
          <div className="shop-chosen__right">
            <ul className="shop-chosen__feature">
              <li className="shop-chosen__feature-item">
                <div className="shop-chosen__feature-left">Anzahl</div>
                <div className="shop-chosen__feature-right">{cartItem.quantity} Stk.</div>
              </li>
              {cartItem.cost ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">Preis je Artikel</div>
                  <div className="shop-chosen__feature-right">{cartItem.cost} &euro;</div>
                </li>
              ) : ( '' )}
              {cartItem.size ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">Gesamtlänge</div>
                  <div className="shop-chosen__feature-right">{cartItem.size} m</div>
                </li>
              ) : ( '' )}
              {cartItem.installation ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">Montage</div>
                  <div className="shop-chosen__feature-right">
                    <img src={iconInstallation} alt="" />
                  </div>
                </li>
              ) : ( '' )}
              {cartItem.bringInWindow ? (
                <li className="shop-chosen__feature-item">
                  <div className="shop-chosen__feature-left">passt nicht durch die Tür / Treppenhaus</div>
                  <div className="shop-chosen__feature-right">
                    <img src={iconInstallation} alt="" />
                  </div>
                </li>
              ) : ( '' )}
            </ul>
          </div>
        </div>
      </li>
    ));
    return (
      <ul className="shop-chosen__list">
        {cartElements}
      </ul>
    )
  };

  renderDeliveryCost = () => {
    const {deliveryData} = this.props;
    return (
      <ul className="delivery-info__cost-list">
        {/*{deliveryData.additional_distance_price ? (*/}
        {/*  <li className="delivery-info__cost-item">*/}
        {/*    <div className="delivery-info__cost-item-left">Additional distance price</div>*/}
        {/*    <div className="delivery-info__cost-item-right">{deliveryData.additional_distance_price} &#8364;</div>*/}
        {/*  </li>*/}
        {/*) : ( '' )}*/}
        {deliveryData.bring_through_window_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Möbellift</div>
            <div className="delivery-info__cost-item-right">{deliveryData.bring_through_window_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.delivery_items_in_trucks ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Liefergebühr</div>
            <div className="delivery-info__cost-item-right">{deliveryData.delivery_items_in_trucks} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.express_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Express Zuschlag</div>
            <div className="delivery-info__cost-item-right">{deliveryData.express_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.lifting_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Lieferung bis in die Wohnung</div>
            <div className="delivery-info__cost-item-right">{deliveryData.lifting_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.installation_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Montage</div>
            <div className="delivery-info__cost-item-right">{deliveryData.installation_price} &#8364;</div>
          </li>
        ) : ( '' )}
        {deliveryData.trucks_required ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Anzahl der Lieferfahrzeuge</div>
            <div className="delivery-info__cost-item-right">{deliveryData.trucks_required}</div>
          </li>
        ) : ( '' )}
        <div className="line-price"></div>
        {deliveryData.total_price ? (
          <li className="delivery-info__cost-item">
            <div className="delivery-info__cost-item-left">Gesamtpreis (brutto)</div>
            <div className="delivery-info__cost-item-right delivery-info__cost-item-right--red">{deliveryData.total_price} &#8364;</div>
          </li>
        ) : ( '' )}
      </ul>
    )
  }

  renderDeliveryDetails = () => {
    const {deliveryAddress, billingDetails} = this.props;
    return (
      <ul className="delivery-info__data-list">
        {billingDetails.name ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Vorname</div>
            <div className="delivery-info__data-item-right">{billingDetails.name}</div>
          </li>
        ) : ( '' )}
        {billingDetails.surname ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Nachname</div>
            <div className="delivery-info__data-item-right">{billingDetails.surname}</div>
          </li>
        ) : ( '' )}
        {billingDetails.phone ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Telefon</div>
            <div className="delivery-info__data-item-right">{billingDetails.phone}</div>
          </li>
        ) : ( '' )}
        {billingDetails.email ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Email</div>
            <div className="delivery-info__data-item-right">{billingDetails.email}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.address_string ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Adresse</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.address_string}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.city ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Stadt</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.city}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.zip ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Postleitzahl</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.zip}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.street ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Strasse</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.street}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.house ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Hausnummer</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.house}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.flat ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Wohnung</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.flat}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.floor ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Etage</div>
            <div className="delivery-info__data-item-right">{deliveryAddress.delivery_address.floor}</div>
          </li>
        ) : ( '' )}
        {/*{deliveryAddress.delivery_to_flat || !deliveryAddress.delivery_to_flat ? (*/}
        {/*  <li className="delivery-info__data-item">*/}
        {/*    <div className="delivery-info__data-item-left">To the floor</div>*/}
        {/*    <div className="delivery-info__data-item-right">{deliveryAddress.delivery_to_flat ? "Ja" : "NEIN"}</div>*/}
        {/*  </li>*/}
        {/*) : ( '' )}*/}
        {deliveryAddress.express_delivery || !deliveryAddress.express_delivery ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Expresslieferung</div>
            <div className="delivery-info__data-item-right">{JSON.parse(deliveryAddress.express_delivery) ? "Ja" : "NEIN"}</div>
          </li>
        ) : ( '' )}
        {billingDetails.order_number ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Belegnummer</div>
            <div className="delivery-info__data-item-right">{billingDetails.order_number}</div>
          </li>
        ) : ( '' )}
        {deliveryAddress.delivery_address.elevator_available || !deliveryAddress.delivery_address.elevator_available ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Aufzug</div>
            <div className="delivery-info__data-item-right">{JSON.parse(deliveryAddress.delivery_address.elevator_available) ? "Ja" : "NEIN"}</div>
          </li>
        ) : ( '' )}
      </ul>
    )
  };

  renderBillingDetails = () => {
    const {billingDetails} = this.props;
    return (
      <ul className="delivery-info__data-list">
        {billingDetails.billing_name ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Vorname</div>
            <div className="delivery-info__data-item-right">{billingDetails.billing_name}</div>
          </li>
        ) : ( '' )}
        {billingDetails.billing_surname ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Nachname</div>
            <div className="delivery-info__data-item-right">{billingDetails.billing_surname}</div>
          </li>
        ) : ( '' )}
        {billingDetails.billing_address.country ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Land</div>
            <div className="delivery-info__data-item-right">{billingDetails.billing_address.country}</div>
          </li>
        ) : ( '' )}
        {billingDetails.billing_address.city ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Stadt</div>
            <div className="delivery-info__data-item-right">{billingDetails.billing_address.city}</div>
          </li>
        ) : ( '' )}
        {billingDetails.billing_address.zip ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Postleitzahl</div>
            <div className="delivery-info__data-item-right">{billingDetails.billing_address.zip}</div>
          </li>
        ) : ( '' )}
        {billingDetails.billing_address.street ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Strasse</div>
            <div className="delivery-info__data-item-right">{billingDetails.billing_address.street}</div>
          </li>
        ) : ( '' )}
        {billingDetails.billing_address.house ? (
          <li className="delivery-info__data-item">
            <div className="delivery-info__data-item-left">Hausnummer</div>
            <div className="delivery-info__data-item-right">{billingDetails.billing_address.house}</div>
          </li>
        ) : ( '' )}
      </ul>
    )
  };

  renderDetails = () => {
    const {deliveryDetails} = this.props;
    return (
      <ul className="delivery-info__data-list">
        { deliveryDetails && deliveryDetails.map((item, index) => {
          return (<li key={index} className="delivery-info__data-item">
            <div className="delivery-info__data-item-day">{moment(item.day).format("DD") + '.'}</div>
            <div className="delivery-info__data-item-month">{moment(item.day).format("MM") + '.'}</div>
            <div className="delivery-info__data-item-year">{moment(item.day).format("YYYY")}</div>
            <div className="delivery-info__data-item-from">von</div>
            <div className="delivery-info__data-item-from-time">{moment(item.from).format("HH")}:00</div>
            <div className="delivery-info__data-item-to">bis</div>
            <div className="delivery-info__data-item-to-time">{moment(item.to).format("HH")}:00</div>
          </li>)
        })}
      </ul>
    )
  };

  handleAgree = () => {
    const {isAgree} = this.state;
    this.setState({
      isAgree: !isAgree
    });
  };

  createOrder = () => {
    const {isAgree} = this.state;
    const {history, deliveryDetails, billingDetails, deliveryAddress, createOrder, clearDeliveryData, clearCart, shopHashUrl} = this.props;
    this.setState({
      isSubmit: true
    });
    if(isAgree) {
      const fetchData = {};
      const tempArr = [];

      const fetchDataDetails = deliveryDetails;
      if(fetchDataDetails && fetchDataDetails.length !==0) {
        for(let i=0; i<fetchDataDetails.length; i++) {
          const tempObj = {};
          tempObj.day = moment(fetchDataDetails[i].day).format("DD/MM/YYYY");
          tempObj.from = moment(fetchDataDetails[i].from).format("HH:mm");
          tempObj.to = moment(fetchDataDetails[i].to).format("HH:mm");
          tempArr.push(tempObj);
        }
      }

      fetchData.delivery_days = deliveryAddress.express_delivery ? tempArr : null;
      fetchData.name = billingDetails.name;
      fetchData.surname = billingDetails.surname;
      fetchData.email = billingDetails.email;
      fetchData.phone = billingDetails.phone;
      fetchData.billing_address = billingDetails.billing_address;
      fetchData.billing_name = billingDetails.billing_name;
      fetchData.billing_surname = billingDetails.billing_surname;
      fetchData.order_number = billingDetails.order_number;
      fetchData.delivery_items = deliveryAddress.delivery_items;
      fetchData.delivery_address = deliveryAddress.delivery_address;
      fetchData.delivery_to_flat = deliveryAddress.delivery_to_flat;
      fetchData.express_delivery = JSON.parse(deliveryAddress.express_delivery);

      this.setState({
        isShowThanksPopup: true
      })
      createOrder(fetchData, shopHashUrl);
      // createOrder(fetchData, 'aaa');
    }
  };

  actionThanksPopup = () => {
    const {clearDeliveryData, clearCart, history} = this.props;
    clearDeliveryData();
    clearCart();
    history.push('/shop/');
  };

  render() {
    const {renderCartList, renderDeliveryCost, renderDeliveryDetails, renderBillingDetails, renderDetails, createOrder} = this;
    const {deliveryAddress, deliveryData} = this.props;
    const {handleAgree, actionThanksPopup} = this;
    const {isAgree, isSubmit, isShowThanksPopup} = this.state;
    return (
      <section className="delivery-info delivered-data">
        <h2>Lieferung</h2>
        <div className="delivery-info__top">
          <div className="delivery-info__left">
            <div className="delivery-info__data delivery-info__data--clients">
              <h3>Rechnungsempfänger</h3>
              { renderBillingDetails() }
            </div>
            { deliveryAddress && !JSON.parse(deliveryAddress.express_delivery) ? (
              <div className="delivery-info__data">
                <h3>Liefertermine</h3>
                { deliveryAddress && !JSON.parse(deliveryAddress.express_delivery) ? (
                  renderDetails()
                ) : ('') }
              </div>
            ) : ('') }
          </div>
          <div className="delivery-info__right delivered-info__right">
            <div className="delivery-info__data">
              <h3>Daten Ihrer Lieferung</h3>
              { renderDeliveryDetails() }
            </div>
          </div>
        </div>
        <div className="delivery-info__bottom">
          <h2>Artikel</h2>
          <div className="delivery-info__categories">
            { renderCartList() }
          </div>
        </div>
        <div className="delivery-info__bottom delivered-data__bottom">
          <h2>Preis</h2>
          <div className="delivery-info__cost">
            { renderDeliveryCost() }
            {(deliveryData && deliveryData.trucks_required > 1) ? (
              <p className="delivery-info__cost-desc">* Aufgrund der Größe wird Ihre Ware in Etappen geliefert.</p>
            ) : ('')}
          </div>
        </div>
        <div className="delivered-data__confirm">
          <div className="delivered-data__confirm-check">
            <input type="checkbox" id="delivered-data-confirm" defaultChecked={isAgree} onClick={handleAgree}/>
            <label htmlFor="delivered-data-confirm">Ich bin mit der Speicherung meiner privatbezogener Daten einverstanden. <span className="red">Informationen zum Datenschutz</span></label>
            <div>{ !isAgree && isSubmit ? (<div style={{color: "red"}}>Fill checkbox</div>) : ('') }</div>
          </div>
          <div className="delivered-data__confirm-btn">
            <button type="button" onClick={createOrder}>Fertig</button>
          </div>
        </div>

        {isShowThanksPopup ? <AlertThanks actionBtn={actionThanksPopup}/> : ''}
      </section>
    );
  }
}

export default withRouter(connect((state) => {
  return {
    deliveryData: state.delivery.deliveryData,
    deliveryAddressErrors: state.delivery.deliveryAddressErrors,
    deliveryAddress: state.delivery.deliveryAddress,
    billingDetails: state.delivery.billingDetails,
    cart: state.cart,
    deliveryDetails: state.delivery.deliveryDetails,
    shopHashUrl: state.categories.shopHashUrl,
  }
}, {createOrder, clearDeliveryData, clearCart})(DeliveredData));


// WEBPACK FOOTER //
// ./src/components/DeliverySteps/DeliveredData.js